module.exports = __webpack_public_path__ + "img/logo.a14d6669.png";